import { Stack } from '@mui/material'
import {
    LabelTypography,
    ValueTypography,
} from 'recruiter/pages/Rosters/RosterProfile/styled'
import { getPxAsRem } from 'shared/utils'

export interface HeaderLabeledDataProps {
    label: string
    data: (string | undefined)[]
    maxWidthPx?: number
}

const HeaderLabeledData: React.FC<HeaderLabeledDataProps> = ({
    data,
    label,
    maxWidthPx = 165,
}) => {
    const truncateData = (items: (string | undefined)[], maxWidth: number) => {
        const ellipsis = '...'
        const maxCharacters = Math.floor(maxWidth / 8) // Approximate character width (adjust as needed)
        let visibleText = ''
        let remainingCount = 0

        if (items.length > 0 && items[0]) {
            const firstItem = items[0]
            if (firstItem.length + ellipsis.length > maxCharacters) {
                visibleText = `${firstItem.slice(0, maxCharacters - ellipsis.length)}${ellipsis}`
                remainingCount = items.length - 1
            } else {
                visibleText = firstItem
                for (let i = 1; i < items.length; i++) {
                    const item = items[i]
                    if (!item) continue

                    const newText = `${visibleText}, ${item}`

                    if (newText.length + ellipsis.length > maxCharacters) {
                        remainingCount = items.length - i
                        break
                    }

                    visibleText = newText
                }
            }
        }

        return {
            visibleText,
            remainingCount,
        }
    }
    const maxWidth = getPxAsRem(maxWidthPx, maxWidthPx)

    const { visibleText, remainingCount } = truncateData(data, maxWidthPx)

    return (
        <Stack
            maxWidth={maxWidth}
            direction={'column'}
            alignItems={'flex-start'}
            justifyContent={'space-between'}
        >
            <LabelTypography variant="overline" noWrap>
                {label.toUpperCase()}
            </LabelTypography>
            <ValueTypography
                maxWidth={'100%'}
                variant="body2"
                sx={{
                    height: getPxAsRem(24, 24),
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                }}
                title={data.map((item) => item).join(', ')}
            >
                {visibleText}
                {remainingCount > 0 && ` +${remainingCount}`}
            </ValueTypography>
        </Stack>
    )
}
export default HeaderLabeledData
